module.exports = __webpack_public_path__ + "img/January.7d5a0596.png";